import { AppProps } from '../../App'
import Landing from './Landing';
import Console from './Console';
import { useEffect } from 'react';

const Home = (props: AppProps) => {
  
  useEffect(() => {
    if (props.user && props.user.plan.name === 'free') {
      window.location.href = '/pricing';
    }
  }, [props.user]);

  return !props.user ? <Landing {...props} /> : (
    props.user.plan.name === 'free' ? <></> : <Console {...props} />
  )
}

export default Home